import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Propan",
  "description": "",
  "published": "2007-01-10T00:00:00.000Z",
  "redirect_from": ["/blog/propan/swizec/324"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><a parentName="p" {...{
        "href": "http://www.liveleak.com/view?i=08b0f84d82&c=1"
      }}>{`Streljanje v propanske rezervoarje`}</a>{` je zabavno, ampak pobje, drzati kamero pri miru bi lahko bilo se toliko bolj.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      